import React, { useState, useEffect } from 'react';
import { Container, IconButton, Box, Button } from '@mui/material';
import DataTable from '../components/DataTable';
import PageTitle from '../components/PageTitle';
import { useConfirm } from '../assets/contexts/confirmContext';
import { useNotification } from '../assets/contexts/notificationContext';
import Loader from '../components/loader';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { ACTION_ICON_COLORS } from '../constants/iconActionColors';
import * as endPoints from '../assets/js/endpoints';
import { useNavigate } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import { Helmet } from 'react-helmet';

const ManageReports = () => {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const confirm = useConfirm();
  const { showNotification } = useNotification();

  const fetchReports = async () => {
    try {
      const data = await endPoints.getReports();
      setReports(Array.isArray(data) ? data : data.data);
    } catch (_err) {
      showNotification('Error al obtener informes', 'error');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReports();
  }, []);

  const handleDelete = async id => {
    const ok = await confirm('¿Eliminar informe?');
    if (!ok) return;
    try {
      await endPoints.deleteReport(id);
      fetchReports();
      showNotification('Informe eliminado', 'success');
    } catch (_err) {
      showNotification('Error eliminando informe', 'error');
    }
  };

  const handleEdit = id => navigate(`/admin/createReport/${id}`);
  const handleCreate = () => navigate('/admin/createReport');

  if (loading) return <Loader />;

  const columns = [
    { id: 'title', label: 'Título' },
    { id: 'clientName', label: 'Cliente' },
    { id: 'serviceName', label: 'Servicio' },
  ];

  const rows = reports.map(r => ({
    ...r,
    clientName: r.client?.name,
    serviceName: r.service?.name,
  }));

  const actions = report => (
    <>
      <IconButton onClick={() => handleEdit(report.id)} sx={{ color: ACTION_ICON_COLORS.edit }}>
        <EditIcon />
      </IconButton>
      <IconButton onClick={() => handleDelete(report.id)} sx={{ color: ACTION_ICON_COLORS.delete }}>
        <DeleteIcon />
      </IconButton>
    </>
  );

  return (
    <>
      <Helmet>
        <title>Gestión de Informes | CES</title>
      </Helmet>
      <Container sx={{ mt:5, paddingBottom:2, mb:2 }}>
        <Box sx={{ display:'flex', justifyContent:'space-between', alignItems:'center', mb:2, flexWrap:'wrap' }}>
          <PageTitle>Gestión de Informes</PageTitle>
          <Button variant="contained" startIcon={<AddIcon />} onClick={handleCreate}>Crear Nuevo Informe</Button>
        </Box>
        <DataTable columns={columns} rows={rows} actions={actions} />
      </Container>
    </>
  );
};

export default ManageReports;
